import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader
} from "reactstrap";
import exceptionHandler from "../../../_helpers/exceptionHandler";
import { api } from "../../../_services/api.service";
import GeneralGrid from "../../../Components/GeneralGrid";
import Loader from "react-loaders";
import FieldBarChart from "../Charts/FieldBarChart";
import AnswerListModal from "./AnswerListModal";

const QuestionResultsCard = ({
  partnerScenarioId,
}) => {
  let [fields, setFields] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [textFields, setTextFields] = useState([]); // fields of type ShortText, LongText and List
  let [otherFields, setOtherFields] = useState([]); // fields different than ShortText, LongText and List
  let [selectedField, setSelectedField] = useState(undefined);
  let [isAnswerModalVisible, setIsAnswerModalVisible] = useState(false);

  useEffect(() => {
    loadFields();
  }, []);

  useEffect(() => {
    if (!fields)
      return;

    let firstType = fields.filter((field, _) => (field.fieldType === 'ShortText' || field.fieldType === 'LongText' || field.fieldType === 'List'));
    setTextFields(firstType);
    setOtherFields(fields.filter((field, _) => (field.fieldType !== 'ShortText' && field.fieldType !== 'LongText' && field.fieldType !== 'List')))
  }, [fields]);

  const loadFields = async () => {
    setIsLoading(true);
    await api.getFieldsByPartnerScenario(partnerScenarioId)
      .then(data => {
        if (data) setFields(data);
      })
      .catch(exceptionHandler);

    setIsLoading(false);
  };

  const toggleAnswerModal = () => {
    setIsAnswerModalVisible(!isAnswerModalVisible);
  };

  const showAnswers = (field) => {
    setSelectedField(field);
    setIsAnswerModalVisible(true);
  };

  const textFieldsColumns = [
    {
      dataField: "fieldLabel",
      text: "Question",
      sort: false,
      headerStyle: () => {
        return { width: "50%" };
      },
      formatter: (cellContent, row) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            key={"xfieldsLabel" + row.fieldID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              showAnswers(row);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
  ];

  return (
    <Card className="main-card mb-3">
      <CardHeader>Fields</CardHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      <CardBody>
        <GeneralGrid
          colWidth={12}
          title={"Short Text, Long Text or List"}
          keyField="fieldID"
          dataSource={textFields}
          columns={textFieldsColumns}
          defaultSortedColumn="orderID"
          showAddButton={false}
        />

        {(otherFields && otherFields.length > 0) && 
          otherFields.map(f => {
            return <FieldBarChart field={f} />
          })
        }
      </CardBody>

      <AnswerListModal 
        field={selectedField}
        showModal={isAnswerModalVisible}
        toggleModal={toggleAnswerModal}
      />
    </Card>
  )
};

export default QuestionResultsCard;